import { useFormikContext } from "formik";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
  FormikCheckbox,
  FormikRadioYN,
  FormikTextarea,
} from "@/features/forms/components/formik-controls";
import type { Form8857Data } from "@/features/forms/types";

/**
 * Part V — Abuse / domestic violence (legacy `sr_part5.php`). Highly sensitive:
 * this content is never logged or sent to analytics. Optional per the IRS form.
 */
export function SrPart5({ onNext }: { onNext: () => void }) {
  const { values } = useFormikContext<Form8857Data>();

  return (
    <div className="flex flex-col gap-6">
      <Card className="flex flex-col gap-4 p-6">
        <p className="text-muted-foreground text-xs">
          This part is optional. If you have concerns about your safety, consider
          contacting the National Domestic Violence Hotline at 1-800-799-SAFE (7233).
        </p>
        <div className="flex flex-col gap-2">
          <span className="text-foreground text-sm">
            <span className="text-muted-foreground mr-2 font-mono">23a</span>
            Were you or a family member a victim of abuse or domestic violence by the
            person on line 6?
          </span>
          <FormikRadioYN name="sp_family_victim" aria-label="Victim of abuse or domestic violence" />
          {values.sp_family_victim === "Y" && (
            <div className="border-t pt-3">
              <FormikCheckbox
                name="remove_code"
                label="Do not put a domestic-violence code on my account"
              />
            </div>
          )}
        </div>

        {values.sp_family_victim === "Y" && (
          <div className="grid gap-2 border-t pt-4">
            <Label htmlFor="abuse_explain">
              <span className="text-muted-foreground mr-2 font-mono">23b</span>
              Describe the abuse and how it affected you or your family
            </Label>
            <FormikTextarea name="abuse_explain" rows={4} />
          </div>
        )}

        <div className="flex flex-col gap-2 border-t pt-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <span className="text-foreground text-sm">
            <span className="text-muted-foreground mr-2 font-mono">23c</span>
            Are you afraid of the person listed on line 6?
          </span>
          <FormikRadioYN name="afraid_of_persion" aria-label="Afraid of the person" />
        </div>
        <div className="flex flex-col gap-2 border-t pt-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <span className="text-foreground text-sm">
            <span className="text-muted-foreground mr-2 font-mono">23d</span>
            Does that person pose a danger to you or your family?
          </span>
          <FormikRadioYN name="pose_danger" aria-label="Person poses a danger" />
        </div>
      </Card>

      <div className="flex justify-end">
        <Button type="button" variant="outline" onClick={onNext}>
          Go to Part VI <ArrowRight />
        </Button>
      </div>
    </div>
  );
}
